import type {BioIconProps} from '../common-types'

export function ChosenByCheckIcon({...attributes}: BioIconProps) {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M8.5 17.16C9.55076 17.1613 10.5914 16.955 11.5622 16.5529C12.533 16.1507 13.4147 15.5608 14.1568 14.8168C14.9007 14.0748 15.4907 13.193 15.8928 12.2222C16.295 11.2515 16.5013 10.2108 16.5 9.16003C16.5013 8.10927 16.295 7.06861 15.8928 6.09783C15.4907 5.12706 14.9007 4.24531 14.1568 3.50324C13.4147 2.7593 12.533 2.16933 11.5622 1.76721C10.5914 1.36508 9.55076 1.15874 8.5 1.16004C7.44924 1.15874 6.40857 1.36508 5.4378 1.76721C4.46702 2.16933 3.58527 2.7593 2.8432 3.50324C2.09927 4.24531 1.50929 5.12706 1.10717 6.09783C0.705051 7.06861 0.49871 8.10927 0.500006 9.16003C0.49871 10.2108 0.705051 11.2515 1.10717 12.2222C1.50929 13.193 2.09927 14.0748 2.8432 14.8168C3.58527 15.5608 4.46702 16.1507 5.4378 16.5529C6.40857 16.955 7.44924 17.1613 8.5 17.16Z"
        stroke="#64748B"
        strokeLinejoin="round"
      />
      <path
        d="M5.30078 9.16001L7.70078 11.56L12.5008 6.76001"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
